<template>
  <div class="file-item">
    <v-icon size="16" class="me-2">fas fa-file</v-icon>
    <b class="file-name">{{ file.name }}</b>
    <button @click="viewFile" class="view-btn">
      <v-icon size="16" color="primary" class="ma-1">fas fa-eye</v-icon>
    </button>
  </div>
</template>

<script>
export default {
  name: 'FileViewer',
  props: {
    file: {
      type: File,
      required: true,
    },
  },
  methods: {
    viewFile() {
      const fileUrl = URL.createObjectURL(this.file);
      window.open(fileUrl, '_blank');
      setTimeout(() => {
        URL.revokeObjectURL(fileUrl);
      }, 100);
    },
  },
};
</script>

<style scoped>
.file-item {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  background-color: #ececec;
  border-radius: 0.5rem;
  border: 1px solid #c2c6c6;
}
.file-name {
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
  font-size: 0.75rem;
  color: #555;
}

.view-btn {
  border: 1px solid #278b97;
  border-radius: 0.5rem;
}
</style>
